export default {
  evaluation_list: {
    title: 'Daftar Pemasok',
    // number_of_companies_answered: "",
    number_of_companies_displayed: 'Tampilkan {start} hingga {end} dari {total} perusahaan',
    company_name: 'Nama Perusahaan',
    status: 'Status',
    questionnaire: 'Survei',
    plan: 'Paket',
    nothing: 'Hasil tidak ditemukan',
  },
  evidence_options: {
    all_plan: 'Semua paket',
    // plans_with_vouchers: "",
    // no_voucher_plan: "",
  },
  table_headers: {
    company_name: 'Nama Perusahaan',
    status: 'Status',
    esg_rating: 'Peringkat ESG',
    esg_score: 'Skor ESG',
    environment: 'Lingkungan',
    social: 'Sosial',
    governance: 'Tata Kelola',
    plan: 'Paket',
    questionnaire: 'Survei',
    answer_date: 'Tanggal jawaban',
    answer_expires_date: 'Tenggat',
  },
  plan_list: {
    // light: "",
    // starter: "",
    // basic: "",
    // standard: "",
    // enterprize: "",
  },
}
